export enum BillOnType {
  BILL_ON_UNSET = 'BILL_ON_UNSET',
  BILL_ON_PLAN_PURCHASE = 'BILL_ON_PLAN_PURCHASE',
  BILL_ON_PLAN_ACTIVATION = 'BILL_ON_PLAN_ACTIVATION',
}

export enum ResourceType {
  UNSET_RESOURCE_TYPE = 'UNSET_RESOURCE_TYPE',
  RESOURCE_TYPE_LINE = 'RESOURCE_TYPE_LINE',
  RESOURCE_TYPE_GROUP = 'RESOURCE_TYPE_GROUP',
}

export enum RetryCondition {
  UNSET = 'UNSET',
  NOT_RETRYABLE = 'NOT_RETRYABLE',
  RETRYABLE = 'RETRYABLE',
  RETRYABLE_WITH_NEW_NUMBER = 'RETRYABLE_WITH_NEW_NUMBER',
}

export interface StatusReason {
  errorCode: number;
  retryCondition: RetryCondition;
  reason: string;
}
